import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=08ce07c6&scoped=true&"
import script from "./PrivacyPage.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=08ce07c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce07c6",
  null
  
)

export default component.exports